import React, { useContext, useState } from 'react'
import { CompanySearchModal, Input, Radio, Pagination } from '@components';
import { AuthContext, useAdminCompany } from '@context';
import { usePositionList } from '@hooks';
import { FormProvider } from 'react-hook-form';
import { ROLES } from '@constants/roles';
import { formatUseYn } from '@utils/formatUseYn';
import { toast } from 'react-toastify';

const Position = () => {
  const { auth, hasPermission } = useContext(AuthContext);
  const canWrite = hasPermission('POS_WRITE');
  const canDelete = hasPermission('POS_DELETE');
  const isAdmin = auth?.role === ROLES.SUPER_ADMIN || auth?.role === ROLES.ADMIN;

  // 전역 선택한 회사 번호 (관리자)
  const { adminCompCode, adminCompName, setAdminCompCode, setAdminCompName } = useAdminCompany();

  const realCompCode = isAdmin ? adminCompCode : auth?.compCode;

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedPosCode, setSelectedPosCode] = useState();

  const {
    methods, data,
    selectedItems, isAllChecked,
    handlePageChange, changePageSize, handleSelectAll, handleSelectItem,
    pageIndex, recordCountPerPage,
    createPosition, updatePosition, deletePosition,
  } = usePositionList(realCompCode);

  const { setValue, reset, handleSubmit } = methods;
   
 
  // 모달에서 선택한 회사 정보
  const handleModalSuccess = () => {
   reset({
     posCode: "",
     posName: "",
     sort: "",
     posLevel: "",
     useYn: "Y",
     notice: "",
   });
   setModalOpen(false);
 };

 const handleRowClick = (item) => {
   handleSelectItem(item.posCode);
   setSelectedPosCode(item.posCode);

   setValue("posCode", item.posCode);
   setValue("posName", item.posName);
   setValue("sort", item.sort);
   setValue("posLevel", item.posLevel ?? "");
   setValue("useYn", String(item.useYn));
   setValue("notice", item.notice);
 };

 const handleAddNew = () => {
   reset({
     posCode: "",
     posName: "",
     sort: "",
     posLevel: "",
     useYn: "Y",
     notice: "",
   });
 };

 const onError = () => {
   toast.warn("필수 입력란을 확인하세요.");
 }

 const onSubmit = async (formData) => {
   if (!realCompCode) {
     toast.warn("회사를 선택해주세요.");
     return;
   }
   if (!formData.posCode) {
     await createPosition(formData);
   } else {
     await updatePosition(formData);
   }
 };

 return (
    <FormProvider {...methods}>
      <div className="contents-wrap">
        <div className="page-title-wrap">
          <h2>
            <span className="icon-dot-circle"></span>
            직위 관리
          </h2>
        </div>

        <div className="tab-cont-wrap">
          <div className="tab-cont-01 on">
            <div className="search-wrap">
              <div className="search-row">
                <div className="search-item date-picker-box">
                  <label>회사</label>
                  {isAdmin ? (
                    <>
                      <Input
                        name="compName"
                        disabled
                        value={adminCompName || ''}
                      />
                      <button type="button" onClick={() => setModalOpen(true)} className="search-icon" />
                      {adminCompCode && (
                        <button
                          type="button"
                          className="btn-cancel"
                          onClick={() => { setAdminCompCode(""); setAdminCompName(""); }}
                        >
                          초기화
                        </button>
                      )}
                    </>
                  ) : (
                    <Input name="compName" disabled value={data?.company?.compName || ''} />
                  )}
                </div>
              </div>
            </div>

            <div className="row-1">
              <section className="wp75">
                <div className="section-tit-wrap">
                  <h3 className="border-left-primary">
                    &nbsp;직위 목록
                    <span className="total-txt">
                      {" "} | 총 <span className="red">{data?.totalCount || 0}</span> 건
                    </span>
                  </h3>
                  {canDelete && <button type="button" className="btn-delete" onClick={deletePosition}>삭제</button>}
                </div>
                <div className="table-container overflow-x-auto table-list-wrapper">
                  <table className="table-list" style={{ width: "100%" }}>
                    <colgroup>
                      <col style={{ width: "5%" }} />
                      <col style={{ width: "5%" }} />
                      <col style={{ width: "20%" }} />
                      <col style={{ width: "8%" }} />
                      <col style={{ width: "8%" }} />
                      <col style={{ width: "9%" }} />
                      <col style={{ width: "20%" }} />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>
                          <input type="checkbox" checked={isAllChecked} onChange={handleSelectAll} />
                        </th>
                        <th>순번</th>
                        <th style={{ textAlign: 'left' }}>직위 명칭</th>
                        <th>정렬</th>
                        <th>레벨</th>
                        <th>사용여부</th>
                        <th style={{ textAlign: 'left' }}>비고</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.resultList && data.resultList.length > 0 ? (
                        data.resultList.map((item, idx) => (
                          <tr
                            key={item.posCode}
                            style={{ 
                              backgroundColor:
                              selectedPosCode === item.posCode ? "#f2f2f2" : "",
                              cursor: "pointer" }}
                            
                            onClick={() => handleRowClick(item)}
                          >
                            <td>
                              <input type="checkbox"
                                checked={selectedItems.includes(item.posCode)}
                                onChange={(e) => {
                                  e.stopPropagation();
                                  handleSelectItem(item.posCode);
                                }}
                              />
                            </td>
                            <td>{(pageIndex - 1) * recordCountPerPage + idx + 1}</td>
                            <td style={{ textAlign: 'left' }}>{item.posName}</td>
                            <td>{item.sort}</td>
                            <td>{item.posLevel ?? 0}</td>
                            <td>{formatUseYn(item.useYn)}</td>
                            <td style={{ textAlign: 'left' }}>{item.notice}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={6} className="table-empty" style={{ textAlign: "center" }}>
                            조회 결과가 없습니다.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '8px' }}>
                    <span style={{ fontSize: '14px', whiteSpace: 'nowrap', color: '#555' }}>페이지당 행 수</span>
                    <select
                      className="form-select form-select-sm"
                      style={{ width: 'auto' }}
                      value={recordCountPerPage}
                      onChange={(e) => changePageSize(Number(e.target.value))}
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                  </div>

                  {data?.paginationInfo && data.paginationInfo.totalRecordCount > 0 && (
                    <Pagination
                      totalPages={Math.ceil(
                        data.paginationInfo.totalRecordCount / data.paginationInfo.recordCountPerPage
                      )}
                      currentPage={pageIndex}
                      onPageChange={handlePageChange}
                      pageRangeDisplayed={10}
                    />
                  )}
              </section>

              {/* 오른쪽 (등록/수정) */}
              <section className="wp25">
                <div className="section-tit-wrap">
                  <h3 className="border-left-primary">&nbsp;직위 등록/수정</h3>
                  <div className="btn-right-box">
                    <ul>
                      {canWrite && <li><button type="button" title="추가" className="btn-add" onClick={handleAddNew}>추가</button></li>}
                      {canWrite && <li><button type="button" title="저장" className="btn-save" onClick={handleSubmit(onSubmit, onError)}>저장</button></li>}
                    </ul>
                  </div>
                </div>

                <Input type="hidden" name="posCode" />

                <table className="table-write">
                  <colgroup>
                    <col style={{ width: "30%" }} />
                    <col style={{ width: "70%" }} />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>직위명칭<span className="red">*</span></th>
                      <td>
                        <Input
                          name="posName"
                          placeholder="예) 부장"
                          className="input-search"
                          style={{ width: "100%", maxWidth: "none" }}
                          rules={{ required:true }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>정렬순서<span className="red">*</span></th>
                      <td>
                        <Input
                          name="sort"
                          placeholder="예) 1"
                          className="input-search"
                          style={{ width: "100%", maxWidth: "none" }}
                          rules={{ required:true }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>직책레벨</th>
                      <td>
                        <Input
                          name="posLevel"
                          type="number"
                          placeholder="0~9"
                          className="input-search"
                          style={{ width: "100%", maxWidth: "none" }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>사용여부<span className="red">*</span></th>
                      <td>
                        <div style={{display:"flex", gap:"15px"}}>
                          <Radio name="useYn" label="사용" value="Y" />
                          <Radio name="useYn" label="사용안함" value="N" />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>비고</th>
                      <td>
                        <Input
                          name="notice"
                          placeholder="비고란"
                          className="input-search"
                          style={{ width: "100%", maxWidth: "none" }}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </section>

            </div>
          </div>
        </div>
      </div>
        {isAdmin && (
        <CompanySearchModal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          onConfirm={handleModalSuccess}
        />
      )}
    </FormProvider>
 );
}

export {Position};